import { useMutation } from "@tanstack/react-query";
import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { customFetch } from "./custom-fetch";

export interface BulkUpdateCatalogCategoryBody {
  ids: number[];
  category: string;
}

export interface BulkUpdateCatalogCategoryResult {
  updated: number;
}

export interface BulkUpdateProductCategoryBody {
  ids: number[];
  category: string;
}

export interface BulkUpdateProductCategoryResult {
  updated: number;
}

export const bulkUpdateCatalogCategory = async (
  body: BulkUpdateCatalogCategoryBody,
  options?: RequestInit,
): Promise<BulkUpdateCatalogCategoryResult> => {
  return customFetch<BulkUpdateCatalogCategoryResult>(`/api/internal-catalog/bulk-category`, {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(body),
  });
};

export const useBulkUpdateCatalogCategory = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    BulkUpdateCatalogCategoryResult,
    TError,
    { data: BulkUpdateCatalogCategoryBody },
    TContext
  >;
}): UseMutationResult<
  BulkUpdateCatalogCategoryResult,
  TError,
  { data: BulkUpdateCatalogCategoryBody },
  TContext
> => {
  return useMutation({
    mutationFn: ({ data }) => bulkUpdateCatalogCategory(data),
    ...options?.mutation,
  });
};

export const bulkUpdateProductCategory = async (
  body: BulkUpdateProductCategoryBody,
  options?: RequestInit,
): Promise<BulkUpdateProductCategoryResult> => {
  return customFetch<BulkUpdateProductCategoryResult>(`/api/products/bulk-category`, {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(body),
  });
};

export const useBulkUpdateProductCategory = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    BulkUpdateProductCategoryResult,
    TError,
    { data: BulkUpdateProductCategoryBody },
    TContext
  >;
}): UseMutationResult<
  BulkUpdateProductCategoryResult,
  TError,
  { data: BulkUpdateProductCategoryBody },
  TContext
> => {
  return useMutation({
    mutationFn: ({ data }) => bulkUpdateProductCategory(data),
    ...options?.mutation,
  });
};
